import React, { createContext, useContext, useCallback, useMemo, useState } from 'react'

const FeatureFlagContext = createContext({})

export const useFeatureFlags = () => useContext(FeatureFlagContext)

export function FeatureFlagProvider({ children }) {
  const [flags, setFlags] = useState({})

  const setFlagsFromLogin = useCallback((featureFlags) => {
    setFlags(featureFlags || {})
  }, [])

  const isEnabled = useCallback(
    (flagKey) => {
      if (!flagKey) return true
      if (flags[flagKey] !== undefined) return flags[flagKey]
      return true
    },
    [flags]
  )

  const isModuleEnabled = useCallback(() => true, [])
  const isPageEnabled = useCallback(() => true, [])

  const value = useMemo(
    () => ({
      isEnabled,
      isModuleEnabled,
      isPageEnabled,
      setFlagsFromLogin,
      clearFlags: () => setFlags({}),
    }),
    [isEnabled, isModuleEnabled, isPageEnabled, setFlagsFromLogin]
  )

  return <FeatureFlagContext.Provider value={value}>{children}</FeatureFlagContext.Provider>
}
